import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWarningSign: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"warning-sign,attention,coution"} maskId="square-filled-radius-0-stroke-1-IconWarningSign"><path fillRule="evenodd" clipRule="evenodd" d="M6.10366 3H17.8957L22.1009 20.8722L21.1275 21.1012L20.3978 18H14.6016L13.8719 21.1012L12.8984 20.8722L13.5742 18H3.60156L2.87185 21.1012L1.89844 20.8722L6.10366 3ZM17.4997 5.68303L14.8368 17H20.1625L17.4997 5.68303Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWarningSign;
